import React from 'react';
import { Button } from 'react-bootstrap';
import ClinicalContactEntry from '../Components/ClinicalContactEntry';
import ModalButton from '../../../ModalButton';
import IClinicalContact from '../../../../interfaces/IClinicalContact';

interface ClinicalContactModalProps {
    keepModalOpen: boolean;
    setKeepModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
    editableClinicalContact: IClinicalContact;
    isCA: boolean;
    isValid: (contact: IClinicalContact) => boolean;
    handleAddNewClinicalContact: () => void;
    handleEditableClinicalContactUpdate: (name: string, value: any) => void;
    setEditableClinicalContact: React.Dispatch<React.SetStateAction<IClinicalContact>>;
    generateNewClientTemplate: (template?: IClinicalContact) => IClinicalContact;
}

const ClinicalContactModal: React.FC<ClinicalContactModalProps> = ({
    setKeepModalOpen,
    editableClinicalContact,
    isCA,
    isValid,
    handleAddNewClinicalContact,
    handleEditableClinicalContactUpdate,
    setEditableClinicalContact,
    generateNewClientTemplate,
}) => {
    return (
        <ModalButton
            modalProps={{ size: 'lg' }}
            confirmBtnText={'Save and close'}
            onConfirmModalBtn={(e) => {
                setKeepModalOpen(false);
                handleAddNewClinicalContact();
            }}
            cancelBtnText={'Close'}
            onCancelModalBtn={() => setEditableClinicalContact(generateNewClientTemplate())}
            modalTitle={'Add clinical contact'}
            buttonText={
                <>
                    <i className={'bi bi-plus-circle me-3'} />
                    Add clinical contact
                </>
            }
            buttonProps={{
                variant: 'outline-secondary',
                className: 'fs-6',
                size: 'lg',
            }}
            cancelButtonProps={{
                variant: 'outline-secondary',
                className: 'fs-6',
            }}
            confirmButtonProps={{
                className: 'text-primary fs-6',
                disabled: !isValid(editableClinicalContact),
            }}
            additionalButtons={
                <Button
                    className={'text-primar fs-6'}
                    data-testid="confirm-and-close-button"
                    disabled={!isValid(editableClinicalContact)}
                    variant="secondary"
                    onClick={() => {
                        setKeepModalOpen(true);
                        handleAddNewClinicalContact();
                    }}
                >
                    Save and add another
                </Button>
            }
        >
            <ClinicalContactEntry
                contact={editableClinicalContact}
                showAge={isCA}
                handleInputChange={handleEditableClinicalContactUpdate}
            />
        </ModalButton>
    );
};

export default ClinicalContactModal;
